// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"487405bd","952":"92b3c086"}[chunkId] + ".chunk.js";
};